import classnames from 'classnames'
import type { ReactNode } from 'react'
import { Component } from 'react'
import type { WithStyles } from 'react-jss'
import withStyles from 'react-jss'
import { Button } from '.'
import type { SaladTheme } from '../SaladTheme'
import logo from './assets/SaladLockup-BlueBg.svg'

const styles = (theme: SaladTheme) => ({
  container: {
    backgroundColor: theme.darkBlue,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flex: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'stretch',
    userSelect: 'none',
  },
  logo: {
    paddingBottom: '2rem',
  },
  column: {
    flex: 1,
    flexShrink: 0,
  },
  contentContainer: {
    color: theme.lightGreen,
    display: 'flex',
    padding: '4rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 1 0',
    flexBasis: 0,
    minWidth: 0,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: (props: Props) => (props.fullHeightImg ? 'stretch' : 'center'),
    flex: '1 1 0',
    flexBasis: 0,
    minWidth: 0,
    overflow: 'hidden',
  },
  image: {
    objectFit: 'cover',
  },
  childrenContainer: {
    paddingTop: '2rem',
    flexGrow: 2,
    alignSelf: 'stretch',
  },
  title: {
    paddingTop: '2rem',
    fontFamily: theme.fontGroteskLight09,
    fontSize: theme.xxLarge,
    lineHeight: '54px',
  },
  subtitle: {
    fontFamily: theme.fontGroteskLight25,
    fontSize: '18px',
    lineHeight: '32px',
    paddingTop: '3rem',
  },
  nextButton: {
    margin: '0 .5rem',
  },
})

interface Props extends WithStyles<typeof styles> {
  title?: string
  subtitle?: string
  image?: string
  rightContent?: ReactNode
  hasBack?: boolean
  nextText?: string
  nextSubmitting?: boolean
  fullHeightImg?: boolean
  onBack?: () => void
  onNext?: () => void
  children?: ReactNode
}

class _OnboardingPage extends Component<Props> {
  public override render(): ReactNode {
    const {
      title,
      nextText,
      onNext,
      nextSubmitting,
      hasBack,
      subtitle,
      onBack,
      image,
      rightContent,
      classes,
      children,
    } = this.props

    return (
      <div className={classnames(classes.container)}>
        <div className={classnames(classes.contentContainer, classes.column)}>
          <img className={classes.logo} src={logo} alt="" />
          {title && <div className={classes.title}>{title}</div>}
          {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          <div className={classes.childrenContainer}>{children}</div>
          <div>
            {hasBack && (
              <Button disabled={!hasBack} onClick={onBack}>
                Back
              </Button>
            )}
            <Button className={classes.nextButton} onClick={onNext} loading={nextSubmitting}>
              {nextText ? nextText : 'Next'}
            </Button>
          </div>
        </div>
        <div className={classnames(classes.imageContainer, classes.column)}>
          {rightContent}
          {!rightContent && image && <img className={classes.image} src={image} alt="" />}
        </div>
      </div>
    )
  }
}

export const OnboardingPage = withStyles(styles)(_OnboardingPage)
